import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import { breakpointsWidthDateTabs } from './breakpoints'

export interface IDaysTabsSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsWidth?: {}
}

export const DaysTabsSkeletonUnit = ({
  breakpointsWidth = breakpointsWidthDateTabs,
  height = '52px',
  ...rest
}: IDaysTabsSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validWidth = breakpointsWidth
    ? getValueForBreakpoint(clientWidth, breakpointsWidth)
    : rest.width

  return <SkeletonUnit width={validWidth} height={height} {...rest} />
}
